import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams, useSearchParams } from "react-router-dom";
import { A6PdfPageSelectionEditCard } from "./edit_card";

export const A6PdfPageSelectionEdit = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const client = searchParams.get("client") || "a6";
  const table_name = "a6_pdf_page_selection";

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <A6PdfPageSelectionEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
